module.exports = __webpack_public_path__ + "assets/btn-open-a901395a.png";